import type { components } from "@/services/customer-schema";
import { faker } from "@faker-js/faker";

faker.seed(0);

const numAccounts = 4;

const balances = [...Array(numAccounts)].map(() => ({
  pendingDeposit: faker.finance.amount({ min: 10000, max: 20000 }),
  pendingWithdrawal: faker.finance.amount({ min: 1000, max: 5000 }),
  available: faker.finance.amount({ min: 100000, max: 500000 }),
  currencyCode: "USD",
}));

export const globalTotal = balances
  .reduce((sum, item) => sum + parseFloat(item.available), 0)
  .toString();

export const globalPendingDeposits = balances
  .reduce((sum, item) => sum + parseFloat(item.pendingDeposit), 0)
  .toString();

export const globalPendingWithdrawals = balances
  .reduce((sum, item) => sum + parseFloat(item.pendingWithdrawal), 0)
  .toString();

export const valuation: components["schemas"]["Valuation"] = {
  totals: {
    pendingDeposit: globalPendingDeposits,
    pendingWithdrawal: globalPendingWithdrawals,
    available: globalTotal,
    currencyCode: "USD",
  },
};
